import _ from 'underscore';
import * as Fields from '@/views/sections/app/modules/components/fields/Details';
import { mapGetters } from 'vuex';

export default {

	data() {
		return {
			// Fields that should not show up on this form
			hiddenFieldTypes: ['photo_gallery', 'file_gallery'],
			fileUploadFieldTypes: ['photo','file'],
		};
	},

	computed: {

		...mapGetters(['currentAccount']),

		hasChildModules() {
			return this.childModules.length > 0;
		},

		childModules() {
			return this.module.children
				? this.module.children.filter(childModule => childModule.subtype === 'child')
				: [];
		},

		visibleFields() {
			// return [ this.module.fields[0], this.module.fields[2], this.module.fields[3] ];
			return this.fields.filter(field => this.isFieldVisible(field));
		},

		fields() {
			return this.module.fields || [];
		},
	},

	methods: {

		isFieldVisible(field) {
			if (this.hiddenFieldTypes.indexOf(field.type) !== -1) {
				return false;
			}

			if (field.config) {
				if (field.config.has_display_conditions && !this.passesDisplayConditions(field)) {
					return false;
				}
				if (field.config.restricted_access && this.currentAccount.access.access_type !== 'ADMIN') {
					return false;
				}
			}

			return true;
		},

		passesDisplayConditions(field) {
			const conditions = (field.config.display_conditions || []);
			const matchedConditions = conditions.filter(condition => {
				const conditionField = _.findWhere(this.fields, { slug: condition.field });
				if (conditionField) {
					switch (condition.operand) {
						case '=':
							return this.row[ conditionField.slug ] == condition.value;
						case '!=':
							return this.row[ conditionField.slug ] != condition.value;
						case 'empty':
							return _.isEmpty(this.row[ conditionField.slug ]);
						case 'not empty':
							return !_.isEmpty(this.row[ conditionField.slug ]);
						default:
							return true;
					}
				}

				return true;
			});

			switch (field.config.display_condition_grouping) {
				case 'all':
					return matchedConditions.length === conditions.length;
				case 'any':
				default:
					return matchedConditions.length > 0;
			}
		},

		/**
		 * Get the Input component forC this field (based on field type)
		 *
		 * @param field
		 * @returns {*}
		 */
		getFieldComponent(field) {
			if (typeof Fields[ field.type ] !== 'undefined') {
				return Fields[ field.type ];
			}

			return 'string';
		},

	},
};
